import { Injectable } from '@angular/core';
import { Constants } from '../Constants';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
@Injectable({
  providedIn: 'root'
})
export class OrganizationService {

  public getState: Observable<any>;
  constructor(private http: HttpClient) { }
  getLegalEntity(requestBody): Observable<any> {
    const url = Constants.BASE_URL + "v1/legal-entity/list";
    const body = requestBody;
    return this.http.post(url, body);
  }

  disableLegalEntityStatus(requestBody): Observable<any> {
    const url = Constants.BASE_URL + "v1/legal-entity/disable";

    const body = requestBody;
    return this.http.post(url, body);
  }
  activeLegalEntityStatus(requestBody): Observable<any> {
    const url = Constants.BASE_URL + "v1/legal-entity/enable";
    const body = requestBody;
    return this.http.post(url, body);
  }

  // Legal Entity Copy Settings
  legalEntityCopySettings(requestBody): Observable<any> {
    const url = Constants.BASE_URL + "v1/settings/legalentity/copylegalentity";    
    const body = requestBody;
    return this.http.post(url, body);

  }
}
